import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PrimeNgModule } from "@primeng";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { ReportingCoreModule } from "../reporting-core.module";
import { QueryBuilderComponent } from "./components/query-builder.component";
import { QueryAutoBuilderComponent } from "./components/query-auto-builder.component";
import { QueryBuilderSqlEditorComponent } from "./components/query-builder-sql-editor.component";
import { QueryTableSelectorModule } from "@main/reporting.v3/query-table-selector/query-table-selector.module";
import { QueryPreviewModule } from "@main/reporting.v3/query-preview/query-preview.module";
import { SqlEditorModule } from "@controls/text-editors/sql-editor/sql-editor.module";
import { MiproSharedModule } from "@mipro/mipro-shared.module";


@NgModule({
    declarations: [
        QueryBuilderSqlEditorComponent,
        QueryAutoBuilderComponent,
        QueryBuilderComponent
    ],
    exports: [QueryBuilderComponent],
    imports: [
        CommonModule,
        PrimeNgModule,
        SqlEditorModule,
        BbwtSharedModule,
        MiproSharedModule,
        QueryPreviewModule,
        ReportingCoreModule,
        QueryTableSelectorModule,
    ]
})
export class QueryBuilderModule {
}